import { useQuery } from "@tanstack/react-query";
import { stageGate } from "@/services/stage-gate";
import { stageGateKey } from "./query-keys";

/**
 * The served stage gate. Never held fresh, against the application's 30 s, so
 * a confirm made in another tab reaches this one when the attorney comes back.
 */
export function useStageGate(taskId: string) {
  return useQuery({
    queryKey: stageGateKey(taskId),
    queryFn: () => stageGate(taskId),
    staleTime: 0,
  });
}
